var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "avue-crud",
        _vm._g(
          _vm._b(
            {
              ref: "crud",
              attrs: { page: _vm.page, "upload-after": _vm.uploadAfter },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "row-del": _vm.onDel,
                "refresh-change": _vm.refreshChange,
                "search-reset": _vm.searchChange,
                "search-change": _vm.searchChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "materialLabelForm",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.formData.materialLabel,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "materialLabel", $$v)
                            },
                            expression: "formData.materialLabel",
                          },
                        },
                        _vm._l(_vm.crud.DIC.materialLabelE, function (item) {
                          return _c(
                            "el-checkbox",
                            { key: item.id, attrs: { label: item.id } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(item.name) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.formData,
                callback: function ($$v) {
                  _vm.formData = $$v
                },
                expression: "formData",
              },
            },
            "avue-crud",
            _vm.bindVal,
            false
          ),
          _vm.onEvent
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }